import useSelectionsD1ConferencesDropdown from './UseSelectionsD1ConferencesDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SelectionsD1ConferencesDropdown = ({ label, name, value, error, message, onChange }) => {
  const { selectionsD1ConferencesState } = useSelectionsD1ConferencesDropdown();

  return selectionsD1ConferencesState.message
    ? <span className={global.LoadingMsg}>{selectionsD1ConferencesState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={selectionsD1ConferencesState.items}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={selectionsD1ConferencesState.areItemsLoaded !== true}
      />
    );
};

export default SelectionsD1ConferencesDropdown;